module.exports = __webpack_public_path__ + "38642fdfbda6fe9e4a04c98c83ead71b.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./src/audio/fr/stay_fr.mp3
 ** module id = 645
 ** module chunks = 0
 **/